 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		97: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"components-video_module-video_module","4":"ibdPage","6":"legacyIbdPage","8":"ad-AdContainer","9":"components-analytics-analytics","10":"components-feature_feed-feature_feed","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"components-not_found_component-not_found_component","19":"components-slug-slug","20":"customCollectionPage","21":"feed","22":"list_page","23":"list_page_2024","24":"loginPage","25":"logoutPage","26":"magazineTagPage","27":"magazine_page","28":"myAccountPage","29":"newsletters_page_marketo","30":"notFoundPage","31":"offerPage","32":"playlistIndexPage","33":"playlistPage","34":"podcastPage","35":"post_page","36":"registerPage","37":"resetPasswordPage","38":"sitemapIndex","39":"sitemapPost","40":"splash_page","41":"stories","42":"subscribePage","43":"tagPage","44":"videoIndex","45":"videoPage","46":"views-containers-layouts-blank_layout-blank_layout","47":"views-containers-layouts-web_layout-web_layout","92":"MarketoNewsletterForm","93":"MicCarousel","94":"MicIcon","95":"MicMobileIconCarousel","96":"Success-SubmissionSuccess","98":"applications-most-innovative-companies","99":"brands_that_matter_2021","100":"brands_that_matter_page","101":"categoryLink","102":"components-ApplyPageImportantDates-ApplyPageImportantDates","103":"components-BackgroundHighlight-BackgroundHighlight","104":"components-BtmCmos-index","105":"components-BtmPastHonereesLogos-index","106":"components-MultiTabList-MultiTabList","107":"components-QuickCarousel-QuickCarousel","108":"components-StickyBar-StickyBar","109":"components-all_feed-all_feed","110":"components-categories","111":"components-config-config","112":"components-editor_highlights-editor_highlights","113":"components-finite_scroll","114":"components-footer-footer","115":"components-franchise_intro-franchise_intro","116":"components-ibd_category-ibd_category","117":"components-image-image","118":"components-magazine_archive-magazine_archive","119":"components-masthead-masthead","120":"components-mcp_section-mcp_section","121":"components-mic_card-mic_card","122":"components-mic_mobile_menu-mic_mobile_menu","123":"components-more-stories-component-more-stories-component","124":"components-newsletters-recaptcha","125":"components-notice","126":"components-piano-pianoBottomBanner","127":"components-podcast_tile-podcast_tile","128":"components-podcast_tile-podcast_tile_featured","129":"components-post-content-insert","130":"components-ranked","131":"components-recirc-recirc","132":"components-related_posts-related_posts","133":"components-related_slider-related_slider","134":"components-sectors_list-sectors_list","135":"components-social-social","136":"components-top_50-top_50","137":"components-top_50_shuffle-top_50_shuffle","138":"components-video_megatron-video_megatron","139":"containers-pages-list_landers-bwi-2020","140":"containers-pages-list_landers-ibd-2020","141":"containers-pages-list_landers-mic-2021","142":"content-innovation_festival_banner","143":"content-sponsor_bar","144":"fc-components-main-components","145":"fc-components-main-components-StickyBar-StickyBar","146":"fc-components-main-containers","147":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","148":"fc-components-main-containers-IbdLayout-IbdLayout","149":"fc-components-main-containers-MicLayout-MicLayout","150":"fc-components-main-containers-WciLayout-WciLayout","151":"fc-components-main-utils-ConditionalWrapper","152":"franchises-BtmApplyPage","153":"franchises-BwiApplyPage","154":"franchises-IbdApplyPage","155":"franchises-MicApplyPage","156":"franchises-NbttApplyPage","157":"franchises-WciApplyPage","158":"innovation_by_design_future_page","159":"innovation_by_design_page_franchise","160":"innovation_by_design_page_franchise_2023","161":"layouts","162":"layouts-mcp","163":"nav_main_menu-nav_main_menu","164":"package_article_list_entry","165":"packages-nav-package_sticky_nav","166":"post-content-sidebar","167":"topics"}[chunkId]||chunkId) + "." + {"1":"f4a151f3c4383b2c9a5a","2":"1599d583ab9faf124ea3","3":"9db683236d5f1a3eae82","4":"4a7c1dcbdb62093160ca","5":"dc2fe6c4a1cc282c2039","6":"920565733d82e9d93b32","7":"446c874d5384bc969dcb","8":"db98f07af373c010b176","9":"5a3c9a5e834ca4673842","10":"19f9fa0133eca33fca8c","11":"58e7a939f3448fccbb82","12":"c5065a03c83497073300","13":"9497fd4437c841c812fb","14":"62fa2b42a6336178c02e","15":"5ec936d3ed564b0f685d","16":"5f04090b5a51e8ad3a9f","17":"d6f25ca60473370fee9f","18":"aef52050efc33753bf74","19":"e9de18683b09268430c0","20":"9f61e037a8496b01087c","21":"c90b55711d2c33f36087","22":"d7ee9f7eeab389daf1c5","23":"dbc1ad15fe0574b5a3b5","24":"9ef86a495c7f02ce5c1c","25":"e8d345f07d8f27a24b39","26":"31813fe8ad5730333c8c","27":"9fb2ab57d66e01cb71aa","28":"06c2c1023ba921c17a76","29":"e782dfe35db4bffd14cd","30":"64c713941e46fd350914","31":"6d03dcdf58afce581805","32":"8b580afd89e20f451243","33":"9934ab35ecf799440dfb","34":"5c4daf2e8ea4c38275e1","35":"34b0cdfd0bed880b42ee","36":"2a477044b67bf080cba2","37":"5622e87f8d635b0e0b54","38":"3f83ce90f789cecc592f","39":"41d78c54ab6986077b50","40":"3b3c021349365beff870","41":"c33ff1e7022576a9612a","42":"baf4992ed8f594214ded","43":"0a29578af41f2d7727aa","44":"d77924956eb1e9aef8f5","45":"1bbc0b087a69c02010a4","46":"64d44c5d31611d0b1ca7","47":"d5da918b9ab0bf7b5d6f","48":"49080920e9954f26488c","49":"64ea835c28308852e286","50":"0c6b371269ce147940a9","51":"690149136c9759c8ad7d","52":"7b248b0951eea21c134f","53":"874f7e06b1a992103733","54":"2b271b14abca7c7f90a8","55":"e18eea09b860392f056a","56":"7ff074298fe73e534c64","57":"8949085a3c711d1554e1","58":"75c29f853f66cc039a6f","59":"57dd4574498c3da9adc8","60":"0ce29b093669e2f10d43","61":"6de1603fe0b703328cae","62":"cde1a4f8135be1a111f9","63":"59adde244923aecfe1fe","64":"e68af5e4d2a772e4ba5b","65":"36d2a0215e5d09cb72ca","66":"508c5bfe2352629fe590","67":"ece9ea97030e0f4db0dd","68":"ed98873c44bd07024b15","69":"045e304362cb05e0fad4","70":"002d0bf6d6fbab8794a6","71":"c6668b215a2e5993a932","72":"2e6c33dbe6d4b94701af","73":"63ad711670d34205425b","74":"ff3021bb305cb7b83408","75":"6660ecd6f6bfaeda03a2","76":"6f44e5a6ea766ea65b3d","77":"012d671ecfefe3f721e6","78":"a9bb4f6a27ac23e3ab26","79":"8654113651fc0d54ba57","80":"64656dd329ca59bd3fc7","81":"af0e1d679bc504bd867e","82":"eef88c1f6ce009bf3064","83":"609154e5397e5f37c163","84":"59d7b5cd1fecac8d79f3","85":"a89021b4a6e8b184f1f3","86":"634ef997d3aeb7cd60bf","87":"55120bb51b7aa35857b3","88":"162dea98b53126a8e35a","89":"6ab55c0a17dc1abda460","90":"b9d28b941d770912481c","91":"e4f8de4b7694acbdc6c8","92":"2179b50a9ceeb105a0fe","93":"bfcb11b914e13ea0ad27","94":"b08334997f35015f2802","95":"fb5cf7618901c6be424a","96":"1295608e2016259415be","98":"5adaba0f9505e51c4a66","99":"d4c037a32bd633aba865","100":"7e5e4d712115836dd922","101":"e925841dfdafb9030ee4","102":"87e82dd7b2a467739ad3","103":"451bb6e751603a6e99a3","104":"bac90431b11a4601c008","105":"c39f62b96a6a863e6b19","106":"ee1f62f886e15e7d78b4","107":"d2ce6e309c58f5a847bc","108":"f76b71f0104a7a0a8640","109":"0977cd59329d96466725","110":"95037e1b648cbf883531","111":"4bfe5e17a311f0ecc9fd","112":"5f2ceaff9ce9ae1ea5b2","113":"c7daa0ad0aeb749b22e3","114":"8eb6eaaa7db0e5138dab","115":"fc2f76c404ab0b7d9ea9","116":"13c0d459983c43e41648","117":"00070f45c127bb7cd195","118":"76fde1ce994cd53999e6","119":"bc2455cbd2e8c8a64b21","120":"245614b3b72b164b4753","121":"4de6d1c031f3e65ad909","122":"fe7894a5deefb0f0b3fd","123":"66cfce1c6d0268fb2ca8","124":"71e88407292a13981da1","125":"ad9646af8745a50ffaac","126":"813c1200b41e45ea8900","127":"fb024a2ab1aa07bd12f6","128":"ed4dcafcec71862ab3b0","129":"4b519100929b2018bbf7","130":"51992c831d5ea4bfa73d","131":"19c24b894483feb50d65","132":"8eecc0c406fec2797d8d","133":"9ac88ed2ea56e7d0229a","134":"6aa2309775665bd3abc9","135":"7719802c84d6ac2e47e9","136":"1051351f63bdfb965da1","137":"8fca5b43a282d483d098","138":"8dcbed4c7c306740c0fe","139":"f5cdefcf6cb9c6cff4b8","140":"e7c379af29245fd9bfe1","141":"855af0f36c064696d8fb","142":"901c3db531066d5b81ca","143":"a1176334ceedf0f8fe8e","144":"432b2efd3969e3629ab0","145":"be96ff4019adab7f434e","146":"c8e32006242546ba3213","147":"5310db68e21f1c4aede8","148":"8f854b106c89316badd3","149":"3dbcc87d0c766e9acd5a","150":"b927889bd1ab192fee75","151":"9dabaaabd85717a16f30","152":"fe9f7d15fadaae238d9a","153":"81289c1e5a5f849364f7","154":"ff680eca1cc048a7336a","155":"edec1702ed0ff74c6be8","156":"37a0f5b78030896507fa","157":"5b205fe0c896b8b18586","158":"5eced7527d2d56546489","159":"11d465102aca6734ecc5","160":"59141c5146b92c950b02","161":"43561f39127bf4492f01","162":"12d213c28c451e9b84a7","163":"aa22865762cf80b5cb19","164":"648f4e4e55b23095716f","165":"0e7c9df959eeeb45cfa4","166":"56424833f2ff47776778","167":"729a2c8acd87aac566ea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([762,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
